export const SET_TOOLBOXES_AVAILABLE = 'SET_TOOLBOXES_AVAILABLE';
export const SET_TOOLBOXES_CURRENT = 'SET_TOOLBOXES_CURRENT';

export const SET_TOOLBOXES_TASK_PENDING = 'SET_TOOLBOXES_TASK_PENDING';
export const SET_TOOLBOXES_TASK_FAILURE = 'SET_TOOLBOXES_TASK_FAILURE';
export const SET_TOOLBOXES_TASK_SUCCESSFUL = 'SET_TOOLBOXES_TASK_SUCCESSFUL';

export const RESET_TOOLBOXES = 'RESET_TOOLBOXES';